module.exports = __webpack_public_path__ + "img/img4.8aefdd88.png";